<template>
  <div>
    <v-card :loading="loading">
      <mixed-table :data="data" :columns="columns" :fetch-data="getDataForTable" :reload-table="reloadTable" :tbProps="tableProps"/>
    </v-card>
  </div>
</template>

<script>

import MixedTable from "@/components/Table/MixedTable.vue";
import {debounce} from "@/custom";
import {dataTableProps} from "@/main";
import axios from "axios";

export default {
  name: "ladderLogList",
  props: {
    id: {
      required: true,
      type: Number
    }
  },
  components: {MixedTable},
  data() {
    return {
      coreAxios: axios.create({
        baseURL: process.env.VUE_APP_URL,
        timeout: 30_000,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem("id_token"),
          Accept: 'application/json',
          "Access-Control-Allow-Origin": "*",
          'Content-Type': 'application/json',
        }
      }),
      url: '/smarts/logs/' + this.id,
      data: {},
      columns: [
        {
          label: 'ردیف',
          transform: (val) => {
            let row = this.data.current_page - 1;
            row = row * this.data.per_page;
            return row + val.row + 1;
          },
          orderable: true,
        },
        {
          label: 'شناسه آگهی',
          name: 'advertise_id',
          transform: (val) => val?.data?.advertise_id ?? '-',
        },
        {
          label: 'عنوان آگهی',
          name: 'advertise_title',
          transform: (val) => val?.data?.advertise?.post?.title ?? '-',
        },
        {
          label: 'شماره آگهی',
          name: 'phone',
          transform: (val) => val?.data?.number?.phone ?? '-',
        },
        {
          label: 'توضیحات',
          name: 'description',
        },
        {
          name: 'confirmed',
          label: 'وضعیت',
          transform: (value) => {
            return value.data.status === 1
                ? '<i class="v-icon notranslate text-success mdi mdi-check-bold theme--dark"></i>'
                : '<i class="v-icon notranslate text-danger mdi mdi-close theme--dark"></i>'
          }
        },
        {
          label: 'تاریخ',
          transform(val) {
            return `<span dir="ltr">${val.data.created_at_p}</span>`
          },
        },
      ],
      tableProps: dataTableProps.tableProps,
      loading:false,
    }
  },
  methods: {
    getDataForTable(url = this.url, query = this.tableProps) {
      this.loading = true;
      this.coreAxios.get(url, {
        params: query
      }).then(response => {
        this.data = response.data.data;
        this.loading = false;
      }).catch(reason => {
        console.log(reason);
      }).finally(() => {
        this.loading = false;
      });
    },
    reloadTable(tableProps) {
      debounce(() => {
        this.tableProps.page = this.data.current_page;
        this.getDataForTable(this.url, tableProps);
      }, 1000);
    },
  },
}
</script>

<style scoped>

</style>